import React from 'react'
import "../Style/Startfree.css"
import Header from './Header'

export default function Startfree() {
  return <>
    <div id="fixHeader1">
        <Header/>
    </div>
    <div id="Section1">
        <h1 className='subsecHeader1'>Choose your Apps</h1>
        <h1 className='subsecHeader2'>Free instant access, no credit card required.</h1>
    </div>
  </>
}